import React from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";

// FOR THE LOGOUT
// import { logoutHeadOfficeRequest } from "store/actions/authActions";
// import { showSuccessToast } from "utils/toastNotification";

export default function Vendor(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("");
  // const dispatch = useDispatch();
  // const navigate = useNavigate();

  // Logout Function
  // const handleLogout = () => {
  //   dispatch(logoutHeadOfficeRequest());
  //   showSuccessToast("Successfully Logout");
  //   navigate("/auth/sign-in");
  // };

  // Handle window resize
  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Set active route
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name || "");
      }
    }
  };

  const getActiveNavbar = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return false;
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/vendor") {
        if (prop.subRoutes) {
          return prop.subRoutes.map((subRoute, subIndex) => (
            <Route
              path={`${prop.path}/${subRoute.path}`}
              element={subRoute.component}
              key={subIndex}
            />
          ));
        }
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      }
      return null;
    });
  };

  return (
    <div className="flex   w-full dark:bg-navy-700">
      <div
        className={`fixed h-full   transition-all duration-300 ease-in-out dark:bg-navy-800 md:relative ${
          sidebarOpen ? "w-64" : "w-20  "
        } z-10 flex-shrink-0`}
      >
        <Sidebar
          open={sidebarOpen}
          onClose={(shouldOpen) => setSidebarOpen(shouldOpen)}
        />
      </div>

      {/* Main Content - with proper spacing */}
      <div
        className={`flex h-full flex-1  flex-col  bg-lightPrimary dark:bg-navy-900 ${
          sidebarOpen ? "ml-0" : "ml-0"
        }`}
      >
        <Navbar
          onOpenSidenav={() => setSidebarOpen(!sidebarOpen)}
          brandText={currentRoute}
          // handleLogout={handleLogout}
          secondary={getActiveNavbar(routes)}
          {...rest}
        />

        <main className="flex-1 overflow-auto table-container1 p-4">
          <Routes>
            {getRoutes(routes)}
            <Route
              path="/"
              element={<navigate to="/vendor/dashboard" replace />}
            />
          </Routes>
        </main>

        <div className="p-3">
          <Footer />
        </div>
      </div>
    </div>
  );
}